module.exports = __webpack_public_path__ + "static/media/Logo Diajeng Hitam-8.5f8c51ce.png";